var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRhpLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRHPLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9999868%",
    y1: "99.9999778%",
    x2: "49.9999868%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD1F24",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B52A26",
    offset: "53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE4D29",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icRHPLogo",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0148788,0 C38.9262007,0.0706976587 50.0074389,11.2558114 50,25.0772037 C49.9925536,38.5869682 38.9736479,50.0130121 24.9674316,50 C10.9956378,49.9878959 -0.44005866,38.4409217 0.013015224,24.1665063 C0.429805983,11.041858 11.1519343,0.0548837087 25.0148788,0 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.609403,24.9711572 C42.5963783,33.129295 36.8571323,40.2009213 28.8683326,41.8744093 C25.0576742,42.6725486 21.3871866,42.2384402 17.8568696,40.572084 C17.5985557,40.4318576 17.288022,40.4266479 17.0251488,40.5581305 C15.9943359,41.0232467 14.952359,41.4613861 13.9206158,41.9237116 C13.3949757,42.1581302 12.8870119,42.165572 12.4320774,41.8037116 C11.9771428,41.4418512 11.8534081,40.9590607 11.9427204,40.387898 C12.1194843,39.2558052 12.2841539,38.1209218 12.4134707,36.9823174 C12.4323567,36.7328893 12.3581091,36.4853146 12.2050753,36.2874338 C9.16101419,32.6868144 7.76550942,28.5348774 8.01856095,23.8316226 C8.0743339,22.9042871 8.21414751,21.9839247 8.43628204,21.0818558 C8.90703232,19.1218562 10.7072335,18.0167402 12.5939559,18.4595308 C14.5113795,18.908833 15.61848,20.7060419 15.1988982,22.6837159 C14.0908674,27.8772031 16.906996,33.0037136 21.8340582,34.7609225 C27.9445085,36.9395267 34.5433854,33.0465043 35.592805,26.6427848 C36.5426785,20.8427861 32.4110541,15.3441826 26.5927295,14.665113 C24.680888,14.4418573 23.522619,13.4325552 23.1951405,11.7088346 C22.7950958,9.59069554 24.7171711,7.45395183 26.8550844,7.70883549 C33.7181769,8.52743996 38.5494144,12.122788 41.3273992,18.4437168 C42.2372684,20.5162745 42.5814929,22.7172042 42.609403,24.9711572 Z M17.3209958,18.3525541 C19.7594078,18.3720889 21.7996358,16.3692987 21.8359189,13.9209271 C21.8731324,11.4437184 19.8487201,9.40092814 17.3386722,9.38325373 C14.8965388,9.36557931 12.8888726,11.3599975 12.8544502,13.8353458 C12.8200277,16.2939499 14.8360669,18.3320889 17.3209958,18.3525541 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRhpLogo);
export default __webpack_public_path__ + "static/media/icRHPLogo.aa630bdf1728162d1a4af90c09db9fc7.svg";
export { ForwardRef as ReactComponent };